import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import EtapasCreate from "./EtapasCreate";
import axios from "axios";
import {
  Button,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  Row,
  Col,
} from "reactstrap";
import Header from "../../../layout/Header/Header";
import Swal from "sweetalert2";
import { puedeCrm } from "../permisosCrm";

function ListadoEtapas() {
  const { user } = useContext(AuthContext);
  const URL_CRM_ETAPAS = process.env.REACT_APP_URL_CRM_ETAPAS;
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;

  const [etapas, setEtapas] = useState([]);
  const [modalCreate, setModalCreate] = useState(false);
  const toggleCreate = () => setModalCreate(!modalCreate);
  const [modal, setModal] = useState(false);
  const toggle = () => setModal(!modal);

  const [idEdit, setIdEdit] = useState();
  const [nombre, setNombre] = useState("");
  const [orden, setOrden] = useState("");
  const [probabilidad, setProbabilidad] = useState(0);
  const [color, setColor] = useState("#6c757d");
  const [tipo, setTipo] = useState("abierta");

  useEffect(() => {
    getEtapas();
  }, []);

  function getEtapas() {
    axios
      .get(URL_CRM_ETAPAS, {
        headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
      })
      .then((response) => setEtapas(response.data))
      .catch((err) => console.log(err));
  }

  function jalaInfo(a) {
    setIdEdit(a._id);
    setNombre(a.nombre);
    setOrden(a.orden);
    setProbabilidad(a.probabilidad);
    setColor(a.color || "#6c757d");
    setTipo(a.tipo || "abierta");
    toggle();
  }

  function editEtapa(event) {
    event.preventDefault();
    axios
      .patch(
        `${URL_CRM_ETAPAS}/${idEdit}`,
        { nombre, orden, probabilidad, color, tipo },
        { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } }
      )
      .then(() => {
        axios.post(
          URL_LOGS,
          { tipo: "Editar Etapa CRM", detalle: nombre, user: user.id },
          { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } }
        );
        toggle();
        Swal.fire("Good job!", "Actualizado con exito", "success");
        // (2026-10) Langiani: sin recargar la página, se refrescan los datos
        getEtapas();
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response ? error.response.data : error}`,
        });
      });
  }

  function sembrarPipeline() {
    Swal.fire({
      title: "Cargar pipeline por defecto?",
      text: "Se crearan las 7 etapas estandar: Nuevo, Contactado / Calificado, Muestra / Prueba, Cotización enviada, Negociación, Ganado y Perdido (solo si aun no hay etapas).",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Si, cargar",
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .post(
            `${URL_CRM_ETAPAS}Seed`,
            {},
            { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } }
          )
          .then((response) => {
            Swal.fire("Listo!", "Pipeline cargado", "success");
            // (2026-10) Langiani: sin recargar la página, se refrescan los datos
            getEtapas();
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: `${error.response ? error.response.data : error}`,
            });
          });
      }
    });
  }

  const badgeTipo = (t) => {
    if (t === "ganada") return <span className="badge badge-success">Ganada</span>;
    if (t === "perdida") return <span className="badge badge-danger">Perdida</span>;
    return <span className="badge badge-secondary">Abierta</span>;
  };

  return (
    <>
      <Header />
      <br />
      <div className="container">
        {puedeCrm(user, "crm.etapas.ver") ? (
          <div className="card col-12">
            <Row>
              <Col md={8}>
                {etapas.length === 0 && (
                  <Button size="sm" color="info" onClick={sembrarPipeline} style={{ marginRight: 8 }}>
                    Cargar pipeline por defecto
                  </Button>
                )}
                {puedeCrm(user, "crm.etapas.crear") && (
<Button size="sm" color="success" onClick={toggleCreate}>
                  Nueva Etapa
                </Button>
)}
              
                <Button size="sm" href="/MenuCrm" className="btn btn-danger" id="botonListado">
                  Regresar
                </Button>
              </Col>
            </Row>
            <h3 align="center">Etapas del Pipeline</h3>
            <Table size="sm" striped borderless className="table-responsive-xl">
              <thead>
                <tr>
                  <th className="tituloTabla">Orden</th>
                  <th className="tituloTabla">Etapa</th>
                  <th className="tituloTabla">Probabilidad</th>
                  <th className="tituloTabla">Color</th>
                  <th className="tituloTabla">Tipo</th>
                  <th className="tituloTabla">Editar</th>
                </tr>
              </thead>
              <tbody>
                {etapas
                  .sort((a, b) => (a.orden > b.orden ? 1 : -1))
                  .map((a) => (
                    <tr key={a._id}>
                      <td>{a.orden}</td>
                      <td>{a.nombre}</td>
                      <td>{a.probabilidad}%</td>
                      <td>
                        <span
                          style={{
                            display: "inline-block",
                            width: 20,
                            height: 20,
                            borderRadius: 4,
                            backgroundColor: a.color,
                          }}
                        />
                      </td>
                      <td>{badgeTipo(a.tipo)}</td>
                      <td>
                        {puedeCrm(user, "crm.etapas.editar") && (
<Button color="info" size="sm" onClick={() => jalaInfo(a)}>
                          <i className="far fa-edit"></i>
                        </Button>
)}
                      </td>
                    </tr>
                  ))}
              </tbody>
            </Table>
          </div>
        ) : undefined}
      </div>

      <Modal size="lg" isOpen={modalCreate} toggle={toggleCreate}>
        <ModalHeader toggle={toggleCreate}>
          Nueva Etapa
        </ModalHeader>
        <ModalBody>
          <EtapasCreate
            onSaved={() => {
              setModalCreate(false);
              getEtapas();
            }}
          />
        </ModalBody>
      </Modal>

      <Modal size="lg" isOpen={modal} toggle={toggle}>
        <ModalHeader toggle={toggle}>
          Editar Etapa
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col md={8}>
              <Label>Nombre</Label>
              <Input type="text" value={nombre} onChange={(e) => setNombre(e.target.value)} />
            </Col>
            <Col md={4}>
              <Label>Orden</Label>
              <Input type="number" value={orden} onChange={(e) => setOrden(e.target.value)} />
            </Col>
          </Row>
          <br />
          <Row>
            <Col md={4}>
              <Label>Probabilidad (%)</Label>
              <Input
                type="number"
                min="0"
                max="100"
                value={probabilidad}
                onChange={(e) => setProbabilidad(e.target.value)}
              />
            </Col>
            <Col md={4}>
              <Label>Color</Label>
              <Input type="color" value={color} onChange={(e) => setColor(e.target.value)} />
            </Col>
            <Col md={4}>
              <Label>Tipo</Label>
              <Input type="select" value={tipo} onChange={(e) => setTipo(e.target.value)}>
                <option value="abierta">Abierta</option>
                <option value="ganada">Ganada (cierra)</option>
                <option value="perdida">Perdida (cierra)</option>
              </Input>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={editEtapa}>
            Guardar
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
}

export default ListadoEtapas;
